module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-422a93814f1b922811514e5eb4e30f02.png";